import { FormControlLabel, Switch, Typography } from "@mui/material";
import { type Control, Controller } from "react-hook-form";
import type { IModalActionForm, IModalActionResolver } from "../../logics/types";

export interface IModalActionFormPinnedProps {
  control: Control<IModalActionForm, void, IModalActionResolver>;
}
export const Pinned = ({ control }: IModalActionFormPinnedProps) => {
  return (
    <Controller
      name="pinned"
      control={control}
      render={({ field }) => (
        <FormControlLabel
          sx={{ width: "100%", display: "flex", justifyContent: "space-between" }}
          control={
            <Switch
              sx={{ marginRight: -1 }}
              onChange={(_, checked) => field.onChange(checked)}
              checked={field.value}
              color="primary"
            />
          }
          label={<Typography>Épingler l’action pour la retrouver plus rapidement </Typography>}
          labelPlacement="start"
        />
      )}
    />
  );
};
